import { doc, GeoPoint, getDoc, setDoc, Timestamp } from "firebase/firestore";
import { firestore } from "../firebase";
import { Place, PlaceDocument } from "../types/Place";
import { User } from "../types/User";
import { generateGeohash } from "../utils/generate-geohash";

export async function createPlaceFromGooglePlaceResult(
  creator: User,
  placeResult: google.maps.places.PlaceResult
) {
  const { place_id, name, formatted_address, geometry } = placeResult;

  if (!place_id || !name || !formatted_address) {
    throw new Error("Invalid place result");
  }

  const placeRef = doc(firestore, "places", place_id);
  const newPlaceDataForFirestore: Omit<PlaceDocument, "id"> = {
    googlePlaceId: place_id,
    name,
    address: formatted_address,
    geohash: undefined,
    checkedInUserIds: [],
    numberOfTables: -1,
    createdAt: Timestamp.now(),
    updatedAt: Timestamp.now(),
    listerUserId: creator.uid,
  };

  if (geometry?.location) {
    const location = new GeoPoint(
      geometry.location.lat(),
      geometry.location.lng()
    );
    newPlaceDataForFirestore.location = location;
    newPlaceDataForFirestore.geohash = generateGeohash(location);
  }

  await setDoc(placeRef, newPlaceDataForFirestore);

  const newPlace: Place = {
    googlePlaceId: place_id,
    name: newPlaceDataForFirestore.name,
    address: newPlaceDataForFirestore.address,
    lat: geometry?.location?.lat() ?? 0,
    lng: geometry?.location?.lng() ?? 0,
    numberOfTables: newPlaceDataForFirestore.numberOfTables ?? -1,
    checkedInUserIds: newPlaceDataForFirestore.checkedInUserIds ?? [],
    createdAt: Timestamp.now(),
    updatedAt: Timestamp.now(),
    listerUserId: creator.uid,
  };
  return newPlace;
}

export async function createPlaceFromGooglePlaceResultIfDNE(
  creator: User,
  placeResult: google.maps.places.PlaceResult
) {
  if (
    !placeResult.place_id ||
    !placeResult.name ||
    !placeResult.formatted_address
  ) {
    return false;
  }

  const placeRef = doc(firestore, "places", placeResult.place_id);
  const placeDoc = await getDoc(placeRef);
  if (placeDoc.exists()) {
    return false;
  }

  await createPlaceFromGooglePlaceResult(creator, placeResult);
  return true;
}
